import type { ReactNode } from 'react';

export interface MatchFilterPillProps {
  /** Whether this filter is currently selected. */
  active?: boolean;
  /** Click handler that toggles/selects the filter. */
  onClick?: () => void;
  /** Pill label content. */
  children: ReactNode;
}

/**
 * Small filter pill for the "All matches" view.
 * Extracted verbatim from the monolith (legacy/App.tsx); markup unchanged so
 * styling is identical.
 */
export function MatchFilterPill({ active, onClick, children }: MatchFilterPillProps) {
  return (
    <button
      onClick={onClick}
      className={`font-mono text-[10px] font-semibold px-2.5 py-1 rounded-full border transition-colors ${active ? 'bg-ink text-white border-ink' : 'border-line text-ink-2 hover:border-ink-3'}`}
    >
      {children}
    </button>
  );
}
